const { save } = require('./save')
const { bulkImport } = require('./bulk-import')

exports.save = save
exports.bulkImport = bulkImport
